import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { SettingsService } from './settings.service';
import { IServerSettings, IServiceError, IUserLoginData } from '../models/index';
import { AuthenticationService } from './authentication.service';
import { catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { DataScopesEnum } from '../../shared/enums/index';
import { StorageManagerService } from './storage-manager.service';
import { headerRefreshed } from '@syncfusion/ej2-angular-grids';

@Injectable({
  providedIn: 'root'
})
export class ApiCredentialsService {

  private action: string;
  private apiGatewayUrl: string;
  private commonApiGatewayUrl: string;
  private data: any;
  private settings: IServerSettings;
  dataScopeEnum = DataScopesEnum;
  private industryId = 1;
  private termUsageId = 2;

  constructor (protected http: HttpClient, private settingsService: SettingsService, private authService: AuthenticationService, private storageManagerService: StorageManagerService) { }

  getApiCredentialsSettingsMock() {
    return this.http.get('../assets/mock/api_credentials_settings.json');
  }

  getApiCredentialsDataMock() {
    return this.http.get('../assets/mock/api_credentials.json');
  }

  getAccessPermissionsMock() {
    return this.http.get('../assets/mock/access-permissions.json');
  }

  getClientLanguagesMock() {
    return this.http.get('../assets/mock/language_grid_mock.json');
  }

  saveApiCredentials(apiCredentials: any, ha: string) {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/Credential/SaveApiCredentials`;

    let headers = this.authService.setHeader();

    headers = headers.set('applicationVariantName', ha.toLowerCase());

    return this.http.post(`${ this.apiGatewayUrl }/${ this.action }`, apiCredentials, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  /**
   * Get API credentials for a specific application variant or the first one available
   * @param customer - Customer object containing application variants   
   */
  getApiCredentials(customer) {
    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/Credential/GetApiCredentialIds`;

    const headers = this.authService.setHeader();
    
    return this.http.get<any>(`${ this.apiGatewayUrl }/${ this.action }`, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  deleteApiCredentials(apiCredentialId: string, appVar: string) {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/Credential/RemoveApiCredentials`;

    let headers = this.authService.setHeader();

    headers = headers.set('applicationVariantName', appVar.toLowerCase());
    headers = headers.set('apiCredentialId', apiCredentialId);

    return this.http.post(`${ this.apiGatewayUrl }/${ this.action }`, null, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  public getSystemLanguages(termCategoryId) {

    this.settings = this.settingsService.getSettings();
    this.commonApiGatewayUrl = this.settings.CommonApiGatewayUrl;
    this.action = `rds/v1/terms/industry?industryId=${ this.industryId }&termusageId=${ this.termUsageId }&categoryId=${ termCategoryId }`;

    const headers = this.authService.setHeader(false, true);

    return this.http.get<any>(`${ this.commonApiGatewayUrl }/${ this.action }`, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  public getClientLanguages() {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/LanguageSupport/LanguageSupportSettings`;

    let headers = this.authService.setHeader(false, true);

    return this.http.get<any>(`${ this.apiGatewayUrl }/${ this.action }`, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  saveChannelLanguageConfig(container: any) {

    this.settings = this.settingsService.getSettings();
    this.apiGatewayUrl = this.settings.ApiGatewayUrl;
    this.action = `rpts/v1/LanguageSupport/LanguageSupportSettings`;

    let headers = this.authService.setHeader(false, true);

    return this.http.post(`${ this.apiGatewayUrl }/${ this.action }`, container, { headers: headers }).pipe(
      catchError(err => this.handleHttpError(err))
    );
  }

  private handleHttpError(error: HttpErrorResponse): Observable<IServiceError> {

    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      const dataError = new IServiceError();
      dataError.errorNumber = error.error ? error.error.number : '';
      dataError.message = error.message;
      dataError.friendlyMessage = error.status ? `Http call failed with status ${ error.status }` : `Http call failed`;
      dataError.errorMessage = error.error ? error.error.message : '';
      dataError.errorStatus = error.status;
      dataError.url = error.url;

      // return an observable of an IServiceError object with a user friendly error message
      return of(dataError);
    }
  }
}
